import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import MyLoader from "../Spinner/MyLoader";
import SessionManager from "../Utils/SessionManager";
import { Link, Redirect } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import "../css/Admin_css/admin-customize.css";
import "../css/Admin_css/modal.css";
import COLORS from "../resources/colors/COLORS";
import myToast from "../Utils/MyToast";
import SelectClass from "../ChildComponent/SelectClass";

const MdlSelectSingleStudent = ({ action, action2 }) => {
  const [loggedIn, setLoggedIn] = useState(
    localStorage.getItem("token") !== null
  );
  const [loading, setLoading] = useState(false);
  const [loadingStudent, setLoadingStudent] = useState(false);
  const [show, setShow] = useState(true);
  const [selectedClassPosition, setSelectedClassPosition] = useState(0);
  const [studentList, setStudentList] = useState([]);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [classId, setClassId] = useState("");
  const [sectionId, setSectionId] = useState("");
  const [sessionId, setSessionId] = useState("");
  const [sessionName, setSessionName] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredStudents, setFilteredStudents] = useState([]);
  const [sortBy, setSortBy] = useState(null); // null, 'name', or 'rollNo'

  useEffect(() => {
    const mSession = SessionManager.getCurrentSession();
    if (mSession && mSession.length > 0) {
      setSessionId(mSession[0].session_id);
      setSessionName(mSession[0].session_name);
    }
  }, []);

  // Filter students based on search term
  useEffect(() => {
    try {
      if (!Array.isArray(studentList)) {
        setFilteredStudents([]);
        return;
      }
      
      let filtered = [];
      if (!searchTerm || searchTerm.trim() === "") {
        filtered = studentList;
      } else {
        const searchLower = searchTerm.toLowerCase();
        filtered = studentList.filter((student) => {
          if (!student) return false;
          return (
            (student.stu_name || "").toLowerCase().includes(searchLower) ||
            (student.student_enrollment_no || "").toLowerCase().includes(searchLower) ||
            (student.father_name || "").toLowerCase().includes(searchLower) ||
            (student.village_town || "").toLowerCase().includes(searchLower) ||
            (student.sr_admission_no || "").toLowerCase().includes(searchLower) ||
            (student.student_roll_no || "").toLowerCase().includes(searchLower) ||
            ((student.class_name || "") + (student.section_id !== "No" ? ":" + (student.section_name || "") : "")).toLowerCase().includes(searchLower)
          );
        });
      }
      
      // Apply sorting if sortBy is set
      if (sortBy) {
        filtered = [...filtered].sort((a, b) => {
          if (sortBy === 'name') {
            return (a.stu_name || '').localeCompare(b.stu_name || '');
          } else if (sortBy === 'rollNo') {
            const rollA = parseInt(a.student_roll_no) || 0;
            const rollB = parseInt(b.student_roll_no) || 0;
            return rollA - rollB;
          }
          return 0;
        });
      }
      
      setFilteredStudents(filtered);
    } catch (error) {
      console.error("Search filter error:", error);
      setFilteredStudents(studentList || []);
    }
  }, [searchTerm, studentList, sortBy]);

  const callBackClassSelect = (
    class_id,
    section_id,
    session_id,
    selected_position,
    class_name,
    section_name,
    session_name
  ) => {
    setClassId(class_id);
    setSectionId(section_id);
    setSessionId(session_id);
    setSelectedClassPosition(selected_position);
    setSortBy(null); // Reset sort when class changes
    getStudentList(class_id, section_id, session_id);
  };

  const getStudentList = (class_id, section_id, session_id) => {
    setLoadingStudent(true);
    setStudentList([]);

    const SCHOOL_CODE = SessionManager.getSchoolCode();
    const FUNCTION_NAME = "getCurrentStudent.php?";
    const URL = `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}${FUNCTION_NAME}`;

    axios
      .get(URL, {
        params: {
          school_code: SCHOOL_CODE,
          class_id,
          section_id,
          session_id,
        },
      })
      .then((res) => res.data)
      .then((response) => {
        setLoadingStudent(false);
        if (response.api_status === "OK") {
          setStudentList(response.data);
        } else {
          myToast.notify_warning(response.api_remark);
        }
      })
      .catch((error) => {
        setLoadingStudent(false);
        console.error("Error fetching students:", error);
      });
  };

  const handleStudentSelection = (student) => {
    setSelectedStudent(student);
  };

  const handleConfirmSelection = () => {
    if (selectedStudent) {
      action2(selectedStudent.student_enrollment_no, selectedStudent, sessionId, sessionName);
      action();
    } else {
      myToast.notify_warning("Please select a student");
    }
  };

  const handleClose = () => {
    setShow(false);
    action();
  };

  const handleSort = (sortType) => {
    if (sortBy === sortType) {
      // If already sorted by this type, reverse the order
      setFilteredStudents([...filteredStudents].reverse());
    } else {
      // Sort by the selected type
      const sorted = [...filteredStudents].sort((a, b) => {
        if (sortType === 'name') {
          return (a.stu_name || '').localeCompare(b.stu_name || '');
        } else if (sortType === 'rollNo') {
          const rollA = parseInt(a.student_roll_no) || 0;
          const rollB = parseInt(b.student_roll_no) || 0;
          return rollA - rollB;
        }
        return 0;
      });
      setFilteredStudents(sorted);
      setSortBy(sortType);
    }
  };

  if (!loggedIn) {
    return <Redirect to="/Login" />;
  }

  return (
    <div>
      <style>
        {`
          .modal-dialog-centered {
            max-width: 1200px !important;
            width: 95% !important;
            max-height: 90vh !important;
          }
          .modal-dialog-centered .modal-content {
            border-radius: 20px 20px 8px 8px;
            overflow: hidden;
            max-height: 90vh;
            display: flex;
            flex-direction: column;
          }
          .modal-dialog-centered .modal-header {
            border-radius: 20px 20px 0 0;
          }
          .modal-dialog-centered .modal-body {
            flex: 1 1 auto;
            overflow-y: auto;
          }
        `}
      </style>
      <Modal
        show={show}
        onHide={handleClose}
        animation={false}
        className="hide-scrollbar"
        dialogClassName="modal-dialog-centered"
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header
          style={{
            background: COLORS.primary_color_shade5,
            color: COLORS.white,
          }}
        >
          <Modal.Title>Select Student</Modal.Title>
          <div style={{ display: "flex", gap: "12px", alignItems: "center", flexWrap: "wrap" }}>
            <div className="text-white fw-bold" style={{ fontSize: "1.2rem" }}>
              {selectedStudent ? `Selected: ${selectedStudent.stu_name}` : "No student selected"}
            </div>
            <div style={{ minWidth: "200px", position: "relative" }}>
              <input
                type="text"
                className="form-control"
                placeholder="Search students..."
                value={searchTerm || ""}
                onChange={(e) => {
                  try {
                    setSearchTerm(e.target.value || "");
                  } catch (error) {
                    console.error("Search input error:", error);
                    setSearchTerm("");
                  }
                }}
                style={{
                  fontSize: "0.9rem",
                  padding: "5px 35px 5px 10px",
                  borderRadius: "15px",
                  border: "1px solid rgba(255,255,255,0.3)",
                  background: "rgba(255,255,255,0.1)",
                  color: "white",
                  backdropFilter: "blur(10px)"
                }}
                onFocus={(e) => {
                  e.target.style.background = "rgba(255,255,255,0.2)";
                  e.target.style.border = "1px solid rgba(255,255,255,0.5)";
                }}
                onBlur={(e) => {
                  e.target.style.background = "rgba(255,255,255,0.1)";
                  e.target.style.border = "1px solid rgba(255,255,255,0.3)";
                }}
              />
              {searchTerm && (
                <button
                  type="button"
                  className="btn btn-sm"
                  onClick={() => setSearchTerm("")}
                  style={{
                    position: "absolute",
                    right: "5px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    background: "transparent",
                    border: "none",
                    color: "white",
                    fontSize: "16px",
                    padding: "2px 5px"
                  }}
                  title="Clear search"
                >
                  ×
                </button>
              )}
            </div>
            <div style={{ display: "flex", gap: "8px", alignItems: "center", borderLeft: "1px solid rgba(255,255,255,0.3)", paddingLeft: "12px" }}>
              <span className="text-white" style={{ fontSize: "0.9rem", fontWeight: "600" }}>Sort By:</span>
              <button
                onClick={() => handleSort('name')}
                style={{
                  background: sortBy === 'name' 
                    ? `linear-gradient(135deg, ${COLORS.highlight_color2} 0%, #FFD700 100%)`
                    : "rgba(255, 255, 255, 0.1)",
                  border: sortBy === 'name' 
                    ? `3px solid ${COLORS.highlight_color2}`
                    : "3px solid rgba(255, 255, 255, 0.5)",
                  color: sortBy === 'name' ? "#000" : "#fff",
                  fontSize: "0.85rem",
                  fontWeight: "600",
                  height: "32px",
                  padding: "0 14px",
                  borderRadius: "8px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  transition: "all 0.3s ease",
                  boxShadow: sortBy === 'name' 
                    ? `0 4px 12px ${COLORS.highlight_color2}50`
                    : "0 2px 4px rgba(0, 0, 0, 0.1)",
                }}
                onMouseEnter={(e) => {
                  if (sortBy !== 'name') {
                    e.currentTarget.style.background = "rgba(255, 255, 255, 0.2)";
                    e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.5)";
                  }
                }}
                onMouseLeave={(e) => {
                  if (sortBy !== 'name') {
                    e.currentTarget.style.background = "rgba(255, 255, 255, 0.1)";
                    e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.5)";
                  }
                }}
                title="Sort by Name"
              >
                <i className="fa fa-sort-alpha-asc" />
                Name
              </button>
              <button
                onClick={() => handleSort('rollNo')}
                style={{
                  background: sortBy === 'rollNo' 
                    ? `linear-gradient(135deg, ${COLORS.highlight_color2} 0%, #FFD700 100%)`
                    : "rgba(255, 255, 255, 0.1)",
                  border: sortBy === 'rollNo' 
                    ? `3px solid ${COLORS.highlight_color2}`
                    : "3px solid rgba(255, 255, 255, 0.5)",
                  color: sortBy === 'rollNo' ? "#000" : "#fff",
                  fontSize: "0.85rem",
                  fontWeight: "600",
                  height: "32px",
                  padding: "0 14px",
                  borderRadius: "8px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  transition: "all 0.3s ease",
                  boxShadow: sortBy === 'rollNo' 
                    ? `0 4px 12px ${COLORS.highlight_color2}50`
                    : "0 2px 4px rgba(0, 0, 0, 0.1)",
                }}
                onMouseEnter={(e) => {
                  if (sortBy !== 'rollNo') {
                    e.currentTarget.style.background = "rgba(255, 255, 255, 0.2)";
                    e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.5)";
                  }
                }}
                onMouseLeave={(e) => {
                  if (sortBy !== 'rollNo') {
                    e.currentTarget.style.background = "rgba(255, 255, 255, 0.1)";
                    e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.5)";
                  }
                }}
                title="Sort by Roll Number"
              >
                <i className="fa fa-sort-numeric-asc" />
                RollNo
              </button>
            </div>
            <button
              onClick={handleConfirmSelection}
              disabled={!selectedStudent}
              style={{
                background: !selectedStudent
                  ? "rgba(255, 255, 255, 0.2)"
                  : `linear-gradient(135deg, ${COLORS.highlight_color2} 0%, #FFD700 100%)`,
                border: !selectedStudent
                  ? "3px solid rgba(255, 255, 255, 0.5)"
                  : `3px solid ${COLORS.highlight_color2}`,
                color: !selectedStudent 
                  ? "rgba(255, 255, 255, 0.5)" 
                  : "#000",
                fontSize: "1rem",
                fontWeight: "700",
                height: "32px",
                padding: "0 20px",
                borderRadius: "8px",
                cursor: !selectedStudent ? "not-allowed" : "pointer",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                transition: "all 0.3s ease",
                boxShadow: !selectedStudent
                  ? "none"
                  : `0 4px 12px ${COLORS.highlight_color2}50`,
                opacity: !selectedStudent ? 0.6 : 1,
              }}
              onMouseEnter={(e) => {
                if (selectedStudent) {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow = `0 6px 16px ${COLORS.highlight_color2}70`;
                }
              }}
              onMouseLeave={(e) => {
                if (selectedStudent) {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = `0 4px 12px ${COLORS.highlight_color2}50`;
                }
              }}
            >
              <i className="fa fa-check-circle" />
              {selectedStudent ? "Done" : "Select a Student"}
            </button>
            <button
              onClick={handleClose}
              style={{
                background: `linear-gradient(135deg, ${COLORS.highlight_color2} 0%, #FFD700 100%)`,
                border: `3px solid ${COLORS.highlight_color2}`,
                color: "#000",
                fontSize: "1.3rem",
                fontWeight: "700",
                width: "32px",
                height: "32px",
                borderRadius: "8px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                transition: "all 0.3s ease",
                boxShadow: `0 4px 12px ${COLORS.highlight_color2}50`,
                lineHeight: "1",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-2px) rotate(90deg)";
                e.currentTarget.style.boxShadow = `0 6px 16px ${COLORS.highlight_color2}70`;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0) rotate(0deg)";
                e.currentTarget.style.boxShadow = `0 4px 12px ${COLORS.highlight_color2}50`;
              }}
              title="Close"
            >
              &times;
            </button>
          </div>
        </Modal.Header>

        <Modal.Body className="hide-scrollbar" style={{ maxHeight: "70vh", overflowY: "auto" }}>
          {loading && (
            <div>
              <MyLoader />
            </div>
          )}
          <div className="row settings-scroll">
            <div className="col-md-12 padding_0">
              <SelectClass
                action={callBackClassSelect}
                selected_position={selectedClassPosition}
              />
              
              {searchTerm && (
                <div className="text-center mb-3">
                  <span className="badge bg-info text-dark">
                    {filteredStudents.length} student{filteredStudents.length !== 1 ? 's' : ''} found
                  </span>
                </div>
              )}
              
              <div className="row bg_card_primary_outline" style={{ margin: "5px 0px", padding: "5px" }}>
                {loadingStudent ? (
                  <div className="col-12 text-center">
                    <MyLoader />
                  </div>
                ) : filteredStudents.length === 0 ? (
                  <div className="col-12 text-center py-4">
                    <div className="text-muted">
                      {searchTerm ? "No students found matching your search" : "No students available"}
                    </div>
                  </div>
                ) : (
                  filteredStudents.map((item, index) => {
                    const isSelected = selectedStudent && selectedStudent.student_enrollment_no === item.student_enrollment_no;
                    return (
                      <div key={index} className="col-6 padding_0" style={{ padding: "6px" }}>
                        <div
                          style={{
                            background: isSelected
                              ? `linear-gradient(135deg, ${COLORS.primary_color_shade1} 0%, ${COLORS.white} 100%)`
                              : "linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)",
                            border: isSelected
                              ? `2px solid ${COLORS.primary_color_shade6}`
                              : "2px solid #e5e7eb",
                            borderRadius: "12px",
                            padding: "16px",
                            cursor: "pointer",
                            transition: "all 0.3s ease",
                            boxShadow: isSelected
                              ? `0 4px 12px ${COLORS.primary_color_shade3}40`
                              : "0 2px 4px rgba(0, 0, 0, 0.05)",
                            position: "relative",
                            overflow: "hidden",
                          }}
                          onClick={() => handleStudentSelection(item)}
                          onMouseEnter={(e) => {
                            if (!isSelected) {
                              e.currentTarget.style.borderColor = COLORS.primary_color_shade4;
                              e.currentTarget.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)";
                              e.currentTarget.style.transform = "translateY(-2px)";
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (!isSelected) {
                              e.currentTarget.style.borderColor = "#e5e7eb";
                              e.currentTarget.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.05)";
                              e.currentTarget.style.transform = "";
                            }
                          }}
                        >
                          {isSelected && (
                            <div style={{
                              position: "absolute",
                              top: "8px",
                              right: "8px",
                              width: "32px",
                              height: "32px",
                              borderRadius: "50%",
                              background: COLORS.primary_color_shade6,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              boxShadow: `0 2px 6px ${COLORS.primary_color_shade3}40`,
                              zIndex: 10,
                            }}>
                              <i className="fa fa-check" style={{ color: "#fff", fontSize: "16px", fontWeight: "bold" }} />
                            </div>
                          )}
                          <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
                            {/* Student Image with Modern Frame */}
                            <div style={{
                              position: "relative",
                              width: "80px",
                              height: "80px",
                              flexShrink: 0,
                            }}>
                              <div style={{
                                position: "absolute",
                                inset: "-4px",
                                borderRadius: "50%",
                                background: `linear-gradient(135deg, ${COLORS.white} 0%, ${COLORS.primary_color_shade1} 100%)`,
                                padding: "3px",
                                boxShadow: `0 4px 12px ${COLORS.primary_color_shade3}60`,
                              }}>
                                <div style={{
                                  width: "100%",
                                  height: "100%",
                                  borderRadius: "50%",
                                  background: "#fff",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  overflow: "hidden",
                                }}>
                                  <img 
                                    src={item.student_img_path} 
                                    alt={item.stu_name}
                                    style={{ 
                                      width: "100%", 
                                      height: "100%", 
                                      objectFit: "cover",
                                      borderRadius: "50%",
                                    }}
                                    onError={(e) => {
                                      e.target.style.display = "none";
                                      if (e.target.nextSibling) {
                                        e.target.nextSibling.style.display = "flex";
                                      }
                                    }}
                                  />
                                  <div style={{
                                    display: "none",
                                    width: "100%",
                                    height: "100%",
                                    background: `linear-gradient(135deg, ${COLORS.primary_color_shade6} 0%, ${COLORS.primary_color_shade4} 100%)`,
                                    alignItems: "center",
                                    justifyContent: "center",
                                    color: "#fff",
                                    fontSize: "32px",
                                    fontWeight: "700",
                                  }}>
                                    {item.stu_name?.charAt(0)?.toUpperCase() || "S"}
                                  </div>
                                </div>
                              </div>
                            </div>
                            
                            {/* Student Info */}
                            <div style={{ flex: 1, minWidth: 0 }}>
                              <div style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                marginBottom: "8px",
                              }}>
                                <h5 style={{ 
                                  margin: 0, 
                                  fontSize: "16px", 
                                  fontWeight: "700", 
                                  color: COLORS.black8 || "#333333",
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "6px",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}>
                                  <i className="fa fa-user" style={{ fontSize: "14px", color: COLORS.primary_color_shade6 }} />
                                  {item.stu_name}
                                </h5>
                              </div>
                              {item.father_name && (
                                <div style={{
                                  fontSize: "12px",
                                  color: "#6b7280",
                                  marginBottom: "10px",
                                  fontWeight: "500",
                                }}>
                                  <i className="fa fa-male" style={{ marginRight: "6px", fontSize: "11px", color: COLORS.primary_color_shade6 }} />
                                  {item.father_name}
                                </div>
                              )}
                              <div style={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: "8px",
                                alignItems: "center",
                              }}>
                                <div style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "4px",
                                  padding: "4px 10px",
                                  background: COLORS.primary_color_shade1 || "#B3E5FC",
                                  borderRadius: "6px",
                                  border: `1px solid ${COLORS.primary_color_shade3 || "#4FC3F7"}`,
                                  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.08)",
                                }}>
                                  <i className="fa fa-hashtag" style={{ color: COLORS.primary_color_shade8 || "#0277BD", fontSize: "10px" }} />
                                  <span style={{ fontSize: "12px", fontWeight: "600", color: COLORS.black8 || "#333333" }}>
                                    RollNo: {item.student_roll_no}
                                  </span>
                                </div>
                                <div style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "4px",
                                  padding: "4px 10px",
                                  background: COLORS.primary_color_shade1 || "#B3E5FC",
                                  borderRadius: "6px",
                                  border: `1px solid ${COLORS.primary_color_shade3 || "#4FC3F7"}`,
                                  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.08)",
                                }}>
                                  <i className="fa fa-graduation-cap" style={{ color: COLORS.primary_color_shade8 || "#0277BD", fontSize: "10px" }} />
                                  <span style={{ fontSize: "12px", fontWeight: "600", color: COLORS.black8 || "#333333" }}>
                                    Class: {item.section_id === "No" ? item.class_name : `${item.class_name}:${item.section_name}`}
                                  </span>
                                </div>
                                {item.sr_admission_no && (
                                  <div style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "4px",
                                    padding: "4px 10px",
                                    background: COLORS.primary_color_shade1 || "#B3E5FC",
                                    borderRadius: "6px",
                                    border: `1px solid ${COLORS.primary_color_shade3 || "#4FC3F7"}`,
                                    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.08)",
                                  }}>
                                    <i className="fa fa-id-card" style={{ color: COLORS.primary_color_shade8 || "#0277BD", fontSize: "10px" }} />
                                    <span style={{ fontSize: "12px", fontWeight: "600", color: COLORS.black8 || "#333333" }}>
                                      SRN: {item.sr_admission_no}
                                    </span>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default MdlSelectSingleStudent;